export const ALERT_TABS = [
  {
    label: "High Over Forecasting",
    value: "HighOverForecasting",
  },
  {
    label: "High Under Forecasting",
    value: "HighUnderForecasting",
  },
  {
    label: "Low Forecast Accuracy",
    value: "LowForecastAccuracy",
  },
  {
    label: "High Outlier Correction",
    value: "HighOutlierCorrection",
  },
  {
    label: "Volatile Forecast ",
    value: "VolatileForecast",
  },

];

export const CUSTOMER_LEVEL_TABLE = [

  {
    label: 'Customer Id',
    key: 'Customer_Number'
  },

  {
    label: '6 Month  Qty',
    key: 'sum_qty'
  },
  {
    label: 'M-6 Qty',
    key: 'M_6_Qty'
  },
  {
    label: 'M-5 Qty',
    key: 'M_5_Qty'
  },
  {
    label: 'M-4 Qty',
    key: 'M_4_Qty'
  },
  {
    label: 'M-3 Qty',
    key: 'M_3_Qty'
  },
  {
    label: 'M-2 Qty',
    key: 'M_2_Qty'
  },
  {
    label: 'M-1 Qty',
    key: 'M_1_Qty'
  },



]

export const REBALANCING_TABLE = [
  {
    label: "District",
    key: "Plant_Code"
  },
  {
    label: "Plant",
    key: "ReBalancePlant"
  },
  {
    label: "Segment",
    key: "Future_ABC_Segmentation_RB"
  },
  {
    label: "OnHand (Qty.)",
    key: "Onhand_RB"
  },
  {
    label: "onHand ($)",
    key: "OnhandDollarValue_RB"
  },
  {
    label: "Monthly Demand Qty (Avg. Last 6M)",
    key: "AvgMonthlyDemandLast6M_RB"
  },
  {
    label: "DOH Current",
    key: "DOH_RB"
  },
  {
    label: "DOH After Transfer",
    key: "DOHAfterTransfer"
  },
]

export const INVENTORY_ALERT_TABS = [
  {
    label: "Potential Overstock",
    pathName: "/inventory/inventory-alerts/po-inventory-managment",
    type: '0',
    dataKey: 'Overstock2'
  },

  {
    label: "Potential Stockout",
    pathName: "/inventory/inventory-alerts/stockout-inventory-managment",
    type: '1',
    dataKey: 'Stockout2'
  },

  {
    label: "Ageing Inventory ",
    pathName: "/inventory/inventory-alerts/inactive-inventory-managment",
    type: '2',
    dataKey: 'Inactive3'
  },
  {
    label: "High DOS",
    pathName: "/inventory/inventory-alerts/overstock-inventory-managment",
    type: '1',
    dataKey: 'Overstock3'
  },
  {
    label: "Low DOS",
    pathName: "/inventory/inventory-alerts/stockout-inventory-managment",
    type: '2',
    dataKey: 'Stockout3'
  },
  {
    label: "TBD",
    pathName: null,
    type: null,
    dataKey: ''
  },
];

export const STATUS_DATA = [
  { label: "Reviewed", value: 1 },
  { label: "Not Reviewed", value: 0 },
  { label: "In Progress", value: 2 },
];
export const PO_ALERT_DATA = [
  { label: "Automatic", value: "automatic" },
  { label: "Manual", value: "manual" },
];
export const HIGHSTOCKOUT_ALERT_DATA = [
  { label: "AdjORQ>75PerOnHand", value: "AdjORQ>75PerOnHand" },
  { label: "Adj ORQ Based on Min ORQ", value: "Adj ORQ Based on Min ORQ" },
];

export const MONTH_Filter = [
  { label: "0", value: 0 },
  { label: "1", value: 1 },
  { label: "2", value: 2 },
];

export const GRAPH_TABLE = [
  {
    label: "Date",
    key: "forecastDate",
  },
  {
    label: "Forecast",
    key: "toolforecast",
  },
  {
    label: "CY Demand",
    key: "processedQty",
  },
  {
    label: "Y-1 Demand",
    key: "processedQtyLY",
  },
  {
    label: "Y-2 Demand",
    key: "processedQtyL2Y",
  },
];

export const LONGTERM_TABLE = [
  {
    label: "Item Id",
    key: "MATERIAL_MATERIAL",
  },
  {
    label: "Branch",
    key: "PLANT_PLANT",
  },
  {
    label: "Actual QTY 6M",
    key: "ActualQty_Last6M",
  },
  {
    label: "Post Transactional Correction (GB)",
    key: "NormalizedQty_Transactional_Last6M",
  },
  {
    label: "Post Monthly Correction (PA)",
    key: "NormalizedPAQty_Monthly_Last6M",
  },
  {
    label: "Reduction % By GB",
    key: "ReductionByGraybar",
  },
  {
    label: "Reduction % By PA",
    key: "ReductionByPA",
  },
  {
    label: "Overall Reduction %",
    key: "OverAllReduction",
  },
];

export const LONGTERM_CUSTOMER_TABLE = [
  {
    label: "Item Id",
    key: "MATERIAL_MATERIAL",
  },
  {
    label: "Branch",
    key: "PLANT_PLANT",
  },
  {
    label: "Customer",
    key: "Customer_Number",
  },
  {
    label: "M-6",
    subHeader: [
      {
        label: "Actual QTY",
        key: "M_6_Actual_Qty",
      },
      {
        label: "Post Trans. Corr. (GB)",
        key: "M_6_Qty",
      },
      {
        label: "#Transactions",
        key: "M_6_Transactions",
      },
    ],
  },
  {
    label: "M-5",
    subHeader: [
      {
        label: "Actual QTY",
        key: "M_5_Actual_Qty",
      },
      {
        label: "Post Trans. Corr. (GB)",
        key: "M_5_Qty",
      },
      {
        label: "#Transactions",
        key: "M_5_Transactions",
      },
    ],
  },
  {
    label: "M-4",
    subHeader: [
      {
        label: "Actual QTY",
        key: "M_4_Actual_Qty",
      },
      {
        label: "Post Trans. Corr. (GB)",
        key: "M_4_Qty",
      },
      {
        label: "#Transactions",
        key: "M_4_Transactions",
      },
    ],
  },
  {
    label: "M-3",
    subHeader: [
      {
        label: "Actual QTY",
        key: "M_3_Actual_Qty",
      },
      {
        label: "Post Trans. Corr. (GB)",
        key: "M_3_Qty",
      },
      {
        label: "#Transactions",
        key: "M_3_Transactions",
      },
    ],
  },
  {
    label: "M-2",
    subHeader: [
      {
        label: "Actual QTY",
        key: "M_2_Actual_Qty",
      },
      {
        label: "Post Trans. Corr. (GB)",
        key: "M_2_Qty",
      },
      {
        label: "#Transactions",
        key: "M_2_Transactions",
      },
    ],
  },
  {
    label: "M-1",
    subHeader: [
      {
        label: "Actual QTY",
        key: "M_1_Actual_Qty",
      },
      {
        label: "Post Trans. Corr. (GB)",
        key: "M_1_Qty",
      },
      {
        label: "#Transactions",
        key: "M_1_Transactions",
      },
    ],
  },
];



export const SUMMARY_EXPORT = [
  { label: "Plant Code", key: "Plant_Code" },
  { label: "District", key: "PLANT_PLANT" },
  { label: "Item Id", key: "MATERIAL_MATERIAL" },
  { label: "Category (added/excluded from last run)", key: "Category" },
];


export const forecastAlertKeys: { [key: string]: string } = {
  "HighOverForecasting": "High Over-Forecasting",
  "HighUnderForecasting": "High Under-Forecasting",
  "LowForecastAccuracy": "Low Forecast Accuracy",
  "HighOutlierCorrection": "High Outlier Correction",
  "VolatileForecast": "Volatile Forecast"
};

export const InventoryAlertKeys: { [key: string]: string } = {
  "Overstock2": "Potential Overstock",
  "Stockout2": "Potential Stockout",
  "Inactive3": "Ageing Inventory",
  "High DOS": "High DOS",
  "Low DOS": "Low DOS"
}       
